var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.placehold)?_c('span',{staticClass:"placeholder-inline__inner",class:{ 'placeholder-inline__inner--reversed': _vm.theme === 'dark' },style:({ 'padding-left': _vm.width })}):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }